import React from "react";
import PropTypes from "prop-types";
import useEmpresa from "../../../../hooks/useEmpresa";
import { Section } from "../../../../components/CustomLayout/CustomLayoutStyles";
import CustomTable from "../../../../components/CustomTable/CustomTable";
import Pagination from "../../../../components/CustomTable/Pagination";
import Tooltip from "../../../../components/Common/Tooltip";
import CustomIcon from "../../../../components/Common/CustomIcon";
import { ProfileOutlined } from "@ant-design/icons";
import CheckRender from "../../../../components/Common/CheckRender";

const ProcedimientosStandVirtualBusquedaDetalle = ({
  coberturas,
  onSelectedDocument,
  currentPage = 1,
  itemsPerPage = 10,
  totalItems = 0,
  onPageChange
}) => {
  const empresa = useEmpresa();

  // Calcular datos para paginación client-side
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = coberturas.slice(startIndex, endIndex);

  const columnas = () => {
    return [
      {
        title: "cobertura",
        dataIndex: "cobertura",
        key: "cobertura",
        width: "20%"
      },
      {
        title: "Procedimiento",
        dataIndex: "descripcion",
        key: "procedimiento",
        width: "60%"
      },
      {
        title: "Documentos",
        dataIndex: "documento",
        key: "documentos",
        width: "20%",
        render: (text, record) => {
          return (
            <Tooltip text="Seleccionar Documentos" placement="top">
              <CustomIcon
                icon={ProfileOutlined}
                style={{ color: empresa?.COLOR_PRINCIPAL, fontSize: 35 }}
                hoverColor={empresa?.COLOR_SECUNDARIO}
                onClick={() => onSelectedDocument(record)}
              />
            </Tooltip>
          );
        }
      }
    ];
  };

  return (
    <>
      <Section
        style={{
          padding: "0px",
          flexDirection: "column",
          gap: "10px",
          alignItems: "center"
        }}
      >
        <CheckRender allowed={coberturas?.length > 0}>
          <CustomTable
            columns={columnas()}
            dataSource={currentItems}
            showPagination={false}
            pageSize={itemsPerPage}
            width={"100%"}
          />
          <Pagination
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            totalItems={totalItems}
            onPageChange={onPageChange}
          />
        </CheckRender>
      </Section>
    </>
  );
};

ProcedimientosStandVirtualBusquedaDetalle.propTypes = {
  coberturas: PropTypes.arrayOf(
    PropTypes.shape({
      cobertura: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired, // Código de la cobertura
      descripcion: PropTypes.string.isRequired, // Descripción del procedimiento
      tipoProcedimiento: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
      ]), // Tipo de procedimiento
      documento: PropTypes.string // Documento asociado (puede ser opcional)
    })
  ).isRequired, // Lista de coberturas, requerida
  onSelectedDocument: PropTypes.func.isRequired, // Función para manejar la selección de documentos
  currentPage: PropTypes.number, // Página actual de la paginación
  itemsPerPage: PropTypes.number, // Número de elementos por página
  totalItems: PropTypes.number, // Total de elementos para la paginación
  onPageChange: PropTypes.func // Función para manejar el cambio de página
};

export default ProcedimientosStandVirtualBusquedaDetalle;
